import { IconDelete24 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var DeletItemSwipeButton = function DeletItemSwipeButton(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/_jsx("button", {
    onClick: onClick,
    className: classNames(styles['button']),
    "data-testid": "DeletItemSwipeButton",
    children: /*#__PURE__*/_jsx(IconDelete24, {
      color: "error_100"
    })
  });
};